module.exports = __webpack_public_path__ + "media/images/bg/mosaic/shodo-lesson-8ac0749e5db4f34c007fbf15b06194c1.jpg";